<template>
  <div
    class="modal fade"
    :class="{ show: show }"
    :style="{ display: show ? 'block' : 'none' }"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content rounded-3">
        <!-- Body -->
        <div class="modal-body d-flex flex-column" style="gap: 32px">
          <div>
            <div class="d-flex justify-content-between">
              <h5 class="fw-bold">Reactive User</h5>
              <button
                type="button"
                class="btn-close"
                @click="$emit('close')"
              ></button>
            </div>
            <p>
              Are you sure you want to reactive {{ user?.fullname }}? They will
              regain access to the dashboard immediately.
            </p>
          </div>
          <div class="d-flex gap-2">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click="$emit('close')"
            >
              Cancel
            </button>
            <button type="button" class="btn btn-success" @click="reactive">
              Reactive
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactiveUser } from "@/api/user-management";

export default {
  name: "ReactiveUserModalComponent",
  props: {
    show: Boolean,
    user: Object,
  },
  methods: {
    async reactive() {
      try {
        const response = await reactiveUser(this.user.id);

        if (response && response.status === "success") {
          this.$emit("reactivated", response.data); // emit ke parent biar bisa refresh list
          this.$swal(
            "Success!",
            "User has been reactivated successfully!",
            "success"
          );
        } else {
          this.$swal(
            "Error",
            response?.message || "Failed to reactive user",
            "error"
          );
        }
      } catch (error) {
        console.error("Error reactivating user:", error);
        this.$swal(
          "Error",
          "Something went wrong while reactivating user",
          "error"
        );
      } finally {
        this.$emit("close");
      }
    },
  },
};
</script>
